var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CACAD5",
    d: "M84.5 50c0 19.054-15.446 34.5-34.5 34.5S15.5 69.054 15.5 50 30.946 15.5 50 15.5 84.5 30.946 84.5 50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9BAB",
    fillRule: "evenodd",
    d: "M50 83.5c18.501 0 33.5-14.999 33.5-33.5S68.501 16.5 50 16.5 16.5 31.499 16.5 50 31.499 83.5 50 83.5m0 1c19.054 0 34.5-15.446 34.5-34.5S69.054 15.5 50 15.5 15.5 30.946 15.5 50 30.946 84.5 50 84.5",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9BAB",
    d: "M79 50.25C79 66.404 65.904 79.5 49.75 79.5S20.5 66.404 20.5 50.25 33.596 21 49.75 21 79 34.096 79 50.25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACAD5",
    fillRule: "evenodd",
    d: "M49.75 78C65.076 78 77.5 65.576 77.5 50.25S65.076 22.5 49.75 22.5 22 34.924 22 50.25 34.424 78 49.75 78m0 1.5C65.904 79.5 79 66.404 79 50.25S65.904 21 49.75 21 20.5 34.096 20.5 50.25 33.596 79.5 49.75 79.5",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26 48a2 2 0 0 1 2-2h44a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H28a2 2 0 0 1-2-2z"
  })));
});
const SvgBlocked = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlocked);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04NC41IDUwQzg0LjUgNjkuMDUzOCA2OS4wNTM4IDg0LjUgNTAgODQuNUMzMC45NDYyIDg0LjUgMTUuNSA2OS4wNTM4IDE1LjUgNTBDMTUuNSAzMC45NDYyIDMwLjk0NjIgMTUuNSA1MCAxNS41QzY5LjA1MzggMTUuNSA4NC41IDMwLjk0NjIgODQuNSA1MFoiIGZpbGw9IiNDQUNBRDUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01MCA4My41QzY4LjUwMTUgODMuNSA4My41IDY4LjUwMTUgODMuNSA1MEM4My41IDMxLjQ5ODUgNjguNTAxNSAxNi41IDUwIDE2LjVDMzEuNDk4NSAxNi41IDE2LjUgMzEuNDk4NSAxNi41IDUwQzE2LjUgNjguNTAxNSAzMS40OTg1IDgzLjUgNTAgODMuNVpNNTAgODQuNUM2OS4wNTM4IDg0LjUgODQuNSA2OS4wNTM4IDg0LjUgNTBDODQuNSAzMC45NDYyIDY5LjA1MzggMTUuNSA1MCAxNS41QzMwLjk0NjIgMTUuNSAxNS41IDMwLjk0NjIgMTUuNSA1MEMxNS41IDY5LjA1MzggMzAuOTQ2MiA4NC41IDUwIDg0LjVaIiBmaWxsPSIjOUI5QkFCIi8+CjxwYXRoIGQ9Ik03OSA1MC4yNUM3OSA2Ni40MDQzIDY1LjkwNDMgNzkuNSA0OS43NSA3OS41QzMzLjU5NTcgNzkuNSAyMC41IDY2LjQwNDMgMjAuNSA1MC4yNUMyMC41IDM0LjA5NTcgMzMuNTk1NyAyMSA0OS43NSAyMUM2NS45MDQzIDIxIDc5IDM0LjA5NTcgNzkgNTAuMjVaIiBmaWxsPSIjOUI5QkFCIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNDkuNzUgNzhDNjUuMDc1OSA3OCA3Ny41IDY1LjU3NTkgNzcuNSA1MC4yNUM3Ny41IDM0LjkyNDEgNjUuMDc1OSAyMi41IDQ5Ljc1IDIyLjVDMzQuNDI0MSAyMi41IDIyIDM0LjkyNDEgMjIgNTAuMjVDMjIgNjUuNTc1OSAzNC40MjQxIDc4IDQ5Ljc1IDc4Wk00OS43NSA3OS41QzY1LjkwNDMgNzkuNSA3OSA2Ni40MDQzIDc5IDUwLjI1Qzc5IDM0LjA5NTcgNjUuOTA0MyAyMSA0OS43NSAyMUMzMy41OTU3IDIxIDIwLjUgMzQuMDk1NyAyMC41IDUwLjI1QzIwLjUgNjYuNDA0MyAzMy41OTU3IDc5LjUgNDkuNzUgNzkuNVoiIGZpbGw9IiNDQUNBRDUiLz4KPHBhdGggZD0iTTI2IDQ4QzI2IDQ2Ljg5NTQgMjYuODk1NCA0NiAyOCA0Nkg3MkM3My4xMDQ2IDQ2IDc0IDQ2Ljg5NTQgNzQgNDhWNTJDNzQgNTMuMTA0NiA3My4xMDQ2IDU0IDcyIDU0SDI4QzI2Ljg5NTQgNTQgMjYgNTMuMTA0NiAyNiA1MlY0OFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";